function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5565 5.39034C13.5226 5.1173 12.387 4.98425 11.1957 4.98425C6.39305 4.98425 2.5 7.13817 2.5 11.9408C2.5 16.7434 6.39305 21.506 11.1957 21.506C15.9983 21.506 19.8913 16.7434 19.8913 11.9408C19.8913 9.75035 19.0748 8.11643 17.7383 6.98078",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9355 10.2018L19.8921 1.5061L21.6312 4.1148",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3518 6.8952C12.6805 6.78563 11.9553 6.72302 11.1944 6.72302C7.83264 6.72302 5.10742 7.89172 5.10742 9.33172C5.10742 10.2526 6.03525 11.0422 7.71612 11.5056L8.58569 14.5491L10.3248 11.9404L11.1944 16.2883L12.064 11.9404C15.1005 11.7935 17.2814 10.6726 17.2814 9.33172C17.2814 8.93694 17.0709 8.5639 16.704 8.22824",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.02191 17.1583C9.02191 17.3983 8.82713 17.5931 8.58713 17.5931C8.34713 17.5931 8.15234 17.3983 8.15234 17.1583C8.15234 16.9183 8.34713 16.7235 8.58713 16.7235C8.82713 16.7235 9.02191 16.9183 9.02191 17.1583V17.1583Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7621 18.8976C10.7621 19.1376 10.5674 19.3323 10.3274 19.3323C10.0874 19.3323 9.89258 19.1376 9.89258 18.8976C9.89258 18.6576 10.0874 18.4628 10.3274 18.4628C10.5674 18.4628 10.7621 18.6576 10.7621 18.8976V18.8976Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.58636 19.3324C8.58636 19.5724 8.39158 19.7671 8.15158 19.7671C7.91158 19.7671 7.7168 19.5724 7.7168 19.3324C7.7168 19.0924 7.91158 18.8976 8.15158 18.8976C8.39158 18.8976 8.58636 19.0924 8.58636 19.3324V19.3324Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBar);
export default __webpack_public_path__ + "static/media/ico-bar.89c152ad.svg";
export { ForwardRef as ReactComponent };